import axios from 'axios'
import api from './api'
import Vue from 'vue';
import router from '@/router'; // 导入你的路由实例
import {
	Toast
} from 'vant';
// import qs from "qs";

Vue.use(Toast);
//创建axios实例对象
const instance = axios.create({
	baseURL: 'https://truemeet.club/api', //服务器地址
	// basTRYL: 'https://api.vnbuomgirl.com/api', //服务器地址
	timeout: 5000, //默认超时时长
	withCredentials: true,
})


//请求拦截器
instance.interceptors.request.use(config => {
	if (config.method === "post") {
		config.headers = {
			'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
		}
	}

	config.headers = {
		'lang': localStorage.getItem('lang'),
	}
	if (localStorage.getItem('token')) {
		config.headers = {
			...config.headers,
			'token': localStorage.getItem('token'),
		}
	}
	return config
}, err => {
	console.error('请求失败', err)
})

// axios 响应拦截器
instance.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		if (error.response) {
			// 处理 401 未授权
			console.log(error.response.status, '12312313')
			if (error.response.status == '401') {
				console.log(this, '12312313')
				// 如果使用了 Vue Router
				router.push({
					path: '/login'
				});
				localStorage.removeItem('token');
			}
		}
		return Promise.reject(error);
	}
);

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
	let result = null
	if (option.method === 'get' || option.method === 'delete') {
		//处理get、delete请求
		await instance[option.method](
			api[option.url], {
				params: option.data
			}
		).then(res => {
			result = res.data
			// result.data = result.data;
		}).catch(err => {
			result = err
		})
	} else if (option.method === 'post' || option.method === 'put') {
		//处理post、put请求
		await instance[option.method](
			api[option.url],
			option.data
		).then(res => {
			result = res.data;
			if (result.code == '401') {
				// console.log(this, '12312313')
				// 如果使用了 Vue Router
				router.push({
					path: '/login'
				});
				localStorage.removeItem('token');
			}
			

		}).catch(err => {
			result = err
		})
	}
	return result
}

export default http